import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { VenueLink } from 'modules/shared-menu/types';

type GetShouldShowVenueListingManagerArgs = {
  isDevEnv: boolean;
  isListingManagerBetaRegattaEnabled: boolean;
  isListingManagerExplicitlyEnabledForRetailVenue: boolean;
  isVenueLevelMenuEditorRegattaEnabled: boolean;
  selectionLink: VenueLink | null | undefined;
  venue: Venue;
  isFullMenuIntegrated: boolean;
};

export const getShouldShowVenueListingManager = ({
  isDevEnv,
  isListingManagerBetaRegattaEnabled,
  isListingManagerExplicitlyEnabledForRetailVenue,
  isVenueLevelMenuEditorRegattaEnabled,
  selectionLink,
  venue,
  isFullMenuIntegrated,
}: GetShouldShowVenueListingManagerArgs) => {
  const venueHasNoMenu = !venue.menu;

  // Always return false if venue already has a classic menu and is not linked to any selection at all
  if (!!venue.menu && !selectionLink) {
    return false;
  }

  // These flags bypass all other requirements (mainly for testing)
  // All environments
  if (isVenueLevelMenuEditorRegattaEnabled || isListingManagerExplicitlyEnabledForRetailVenue) {
    return !!selectionLink?.selection_id || venueHasNoMenu;
  }

  // If venue is Menu integrated and has no menu yet, direct to CME creation
  if (isFullMenuIntegrated && venueHasNoMenu) {
    return false;
  }

  // Follow the Regatta flag in development
  // No product line or shared/single restrictions
  if (isDevEnv) {
    return isListingManagerBetaRegattaEnabled && (!!selectionLink?.selection_id || venueHasNoMenu);
  }

  /* _______________________________ */
  /* PRODUCTION SPECIFIC RULES BELOW */
  /* _______________________________ */

  const venueIsRestaurant = venue.product_line === 'restaurant';

  const venueHasSingleVenueSelection = selectionLink && selectionLink.selection_is_shared === false;
  const venueHasSharedSelection = selectionLink && selectionLink.selection_is_shared === true;

  // The shared Listing Manager with overrides is not yet released at all in production
  if (venueHasSharedSelection) {
    return false;
  }

  // If venue has no menu yet & is a restaurant, follow Regatta flag
  if (venueHasNoMenu && venueIsRestaurant) {
    return isListingManagerBetaRegattaEnabled;
  }

  // If venue has no menu yet & is NOT a restaurant, show classic
  if (venueHasNoMenu && !venueIsRestaurant) {
    return false;
  }

  // If venue already has a single venue selection, follow Regatta flag
  if (venueHasSingleVenueSelection) {
    return isListingManagerBetaRegattaEnabled;
  }

  // Venue has existing classic menu & no link to Offering Platform
  return false;
};
